import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash/get';

import { Label } from '@hydra/common/components';
import List from '@hydra/routes/crawler/components/List';
import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';
import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import formatNumber from '@hydra/utils/formatNumber';

import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  label: {
    marginRight: theme.spacing(4)
  }
}));

export function ContentIssueRow ({ columnStyles, issue, className, ...props }) {
  const classes = useStyles();
  const domain = get(props, ['relay', 'route', 'params', 'url'], '');
  const urls = issue.urls.map(url => new DCUrl(domain, url));

  return (
    <Grid container className={classnames(classes.root, className)}>
      <Grid item {...columnStyles[0]}>
        <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.urls.length} />
      </Grid>
      <Grid item {...columnStyles[1]}>
        <Label className={classes.label} noBackground justifyContent='flex-end'>
          {formatNumber(issue.content_len_wrd)}
        </Label>
      </Grid>
      <Grid item {...columnStyles[2]}>
        <List style={parseSeverity(issue.severity)} items={urls} />
      </Grid>
    </Grid>
  );
}

ContentIssueRow.propTypes = {
  issue: PropTypes.shape({
    urls: PropTypes.array,
    type: PropTypes.string
  }).isRequired,
  columnStyles: PropTypes.array,
  relay: PropTypes.shape({
    route: PropTypes.shape({
      params: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })
};

export default createFragmentContainer(ContentIssueRow, {
  issue: graphql`
    fragment ContentIssueRow_issue on ContentIssue {
      id
      type
      severity
      content_len_wrd
      urls
    }
  `
});
